import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Layouts from "../../layouts/layouts";
import DataTable from "react-data-table-component";

export default function InsuranceHistory() {
  const { id } = useParams();
  const [history, setHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/insurance-history/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (Array.isArray(response.data.data)) {
        setHistory(response.data.data);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  // Styled badge for done date
  const DoneDateBadge = ({ doneDate, dueDate }) => {
    if (!doneDate) return <span className="text-secondary">—</span>;

    const done = new Date(doneDate);
    const due = new Date(dueDate);
    const isLate = done > due;

    const bg = isLate ? "#fdecea" : "#e8f5e9";
    const color = isLate ? "#c62828" : "#2e7d32";
    const label = isLate ? "Late" : "On Time";

    return (
      <div
        style={{
          backgroundColor: bg,
          color,
          fontWeight: "600",
          borderRadius: "20px",
          padding: "4px 10px",
          display: "inline-block",
          textAlign: "center",
          minWidth: "110px",
        }}
      >
        {formatDate(doneDate)}
        <div style={{ fontSize: "0.8rem", opacity: 0.8 }}>{label}</div>
      </div>
    );
  };

  const columns = [
    {
      name: <b>Vehicle Number</b>,
      selector: (row) => (row.vehicleId ? row.vehicleId.numberplate : "N/A"),
      sortable: true,
    },
    {
      name: <b>Due Date</b>,
      selector: (row) => formatDate(row.Date),
      sortable: true,
    },
    {
      name: <b>Paid Amount (₹)</b>,
      selector: (row) => (row.amountPaid ? `₹${row.amountPaid}` : "-"),
      sortable: true,
      center: true,
    },
    {
      name: <b>Done Date</b>,
      cell: (row) => (
        <DoneDateBadge doneDate={row.DoneDate} dueDate={row.Date} />
      ),
      sortable: true,
      center: true,
    },
    {
      name: <b>Comments</b>,
      selector: (row) => row.comments || "-",
      sortable: true,
      wrap: true,
    },
  ];

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div
              className="card shadow-sm border-0"
              style={{ borderTop: "3px solid #4723d9", borderRadius: "10px" }}
            >
              <div className="card-header d-flex justify-content-between align-items-center bg-light border-bottom pb-1 rounded-top">
                <h5 className="fw-bold mb-0 text-dark">Insurance History</h5>
              </div>
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={history}
                  pagination
                  fixedHeader
                  highlightOnHover
                  responsive
                  striped
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: "#f7f7f9",
                        color: "#333",
                        fontWeight: "bold",
                        fontSize: "14px",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "14px",
                        minHeight: "60px",
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
